// extracted by mini-css-extract-plugin
export default {"wrapper":"tnF0F"};